import {ComponentPropertiesPane} from '../components/NodePropertiesPane.jsx'
import LongText from '../../SidePanel/RightPanel/PropertiesControllerLongText.jsx'
import Model from './ModelFres.mjs'

const PropertiesPaneFres = (props) => (
    <ComponentPropertiesPane
        controllers={
            <>
                <LongText prop="resTitle" />
            </>
        }

        Model={Model}
        sn={null}
        {...props}
    />
)

export default PropertiesPaneFres
